import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { InfoTooltipComponent } from '../../../../components/info-tooltip/info-tooltip.component';

@Component({
    selector: 'app-dashboard-title',
    templateUrl: './dashboard-title.component.html',
    styleUrls: ['./dashboard-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InfoTooltipComponent],
})
export class DashboardTitleComponent {
    readonly title = input<string>('');
    readonly tooltipText = input<string>('');
    readonly subtitle = input<string>('');
}
